import { Typography } from "@mui/material";
import { StepperNavBackgroundWrapper } from "./company-header.style";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import { Button } from "../../../../components/button/button";
import { EditIcon } from "../../../../utils/svg-components";
import { useAuth } from "../../../../context/AuthContext";
import { CircularIconButton } from "../../../../components/circular-button/circular-button.styles";

const CompanyHeader = (props) => {
  const {
    companyDetails,
    activeTab,
    isEditMode,
    setIsEditMode,
    isSaving,
    handleSave,
    isSaveEnabled,
  } = props;

  const { userPermissions } = useAuth();

  const navigate = useNavigate();
  return (
    <StepperNavBackgroundWrapper>
      <div className="flex">
        <CircularIconButton onClick={() => navigate("/companiesview")}>
          <ChevronLeft />
        </CircularIconButton>
        <div>
          <div className="head-flex">
            <Typography variant="h5">{companyDetails?.companyName}</Typography>
          </div>
          <div className="head-flex">
            <Typography variant="body3">
              {`ID: ${companyDetails?.id} `}
            </Typography>
          </div>
        </div>
      </div>
      <div>
        {activeTab === "basic-info" && (
          <div>
            {userPermissions !== "General" && !isEditMode && (
              <Button
                variant="filled"
                color={"tertiary"}
                size="medium"
                onClick={() => setIsEditMode(true)}
                startIcon={<EditIcon />}
              >
                Edit Company
              </Button>
            )}

            {userPermissions !== "General" && isEditMode && (
              <Button
                variant="filled"
                id="saveButton"
                color={"tertiary"}
                size="medium"
                onClick={handleSave}
                startIcon={<EditIcon />}
                isLoading={isSaving}
              >
                Save Company
              </Button>
            )}
          </div>
        )}
      </div>
    </StepperNavBackgroundWrapper>
  );
};

export default CompanyHeader;
